import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { wishlistService } from '../services/wishlist';

const WishlistPage = () => {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    setWishlist(wishlistService.getWishlist());
  }, []);

  const removeFromWishlist = (productId) => {
    const updated = wishlistService.removeFromWishlist(productId);
    setWishlist(updated);
  };

  const addToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    
    // Create cart item with proper structure
    const cartItem = {
      productId: product.id,
      name: product.name,
      price: product.price,
      imageUrl: product.image_url,
      quantity: 1,
      selectedPlatform: 'android',
      selectedPrice: product.price,
      cartKey: `${product.id}-android`
    };
    
    const existing = cart.find(item => item.cartKey === cartItem.cartKey);
    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push(cartItem);
    }
    
    localStorage.setItem('cart', JSON.stringify(cart));
    window.dispatchEvent(new Event('storage'));
    
    // Remove from wishlist after adding to cart
    const updated = wishlistService.removeFromWishlist(product.id);
    setWishlist(updated);
  };

  return (
    <div className="wishlist-page">
        <Breadcrumbs items={[
          { label: 'Home', link: '/' },
          { label: 'Wishlist' }
        ]} />
        
        <h1>My Wishlist</h1>

        {wishlist.length === 0 ? (
          <div className="wishlist-empty">
            <img src="/assets/icons/wishlist-outline.svg" alt="Empty" className="wishlist-empty-icon" />
            <h2>Your wishlist is empty</h2>
            <Link to="/" className="wishlist-empty-link">
              Browse Products
            </Link>
          </div>
        ) : (
          <div className="wishlist-grid">
            {wishlist.map(product => (
              <div key={product.id} className="wishlist-card">
                <button onClick={() => removeFromWishlist(product.id)} className="wishlist-remove-btn" aria-label="Remove from wishlist">×</button>
                
                <img src={product.image_url} alt={product.name}
                  onError={(e) => e.target.src = '/assets/images/coming-soon.jpg'}
                  className="wishlist-image" />
                
                <h3 className="wishlist-title">{product.name}</h3>
                <p className="wishlist-price">
                  ${product.price}
                </p>
                
                <div className="wishlist-actions">
                  <button onClick={() => addToCart(product)} className="wishlist-add-btn">
                    Add to Cart
                  </button>
                  <Link to={`/product/${product.slug}`} className="wishlist-view-link">
                    View
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default WishlistPage;
